import React from 'react';

type LogoProps = {
    src?: string;
    [key: string]: unknown;
};

export function renderUdemyLogo(logoUrl: string) {
    return function RenderUdemyLogo(
        Component: React.ComponentType<LogoProps>,
        props: LogoProps,
    ): React.ReactElement {
        return <Component {...props} src={logoUrl} />;
    };
}
